import React, { useState, useEffect } from 'react'
import { useTranslation } from 'i18n'

import Game from './components/Game'
import analytics from 'global/AnalyticsData'
import MemoryMatchResultsOverlay from './components/MemoryMatchResultsOverlay'
import ShareIcons from 'components/ShareIcons'
import './MemoryMatch.scss'

const MemoryMatchStep = ({
  brk,
  step,
  onEngage = function () {},
  onAwardPoints = function () {},
  nextStepButton,
  skipButton,
}) => {
  const { t } = useTranslation('memoryMatch')
  const memoryMatchData = step.memoryMatchGame
  const [resultsModalOpen, setResultsModalOpen] = useState(false) //is results modal open?
  const [gameRunning, setGameRunning] = useState(false) //This switch gets watched by game to start/restart the action.
  const [results, setResults] = useState(null) //results
  const [movesRemaining, setMovesRemaining] = useState(null) //player moves remaining in active game
  const [userTouchedCard] = useState(false) //to show if cards are flipped

  const socialShareComponent = step.socialShareOn && (
    <ShareIcons
      facebookShare={step.facebookShare}
      twitterShare={step.twitterShare}
      pinterestShare={step.pinterestShare}
      emailShare={step.emailShare}
      emailConfig={{
        subject: step.shareEmailSubject,
        body: step.shareEmailBody,
      }}
      copyShare={step.copyShare}
      whatsappShare={step.whatsappShare}
    />
  )

  const handleResults = results => {
    analytics.stepEvent('step_interaction_memory_match_complete', step, {
      number_of_matches: results.cardsCleared / 2,
      total_number_of_cards: results.totalCards,
    })

    setGameRunning(false)
    setResults(results)
    setResultsModalOpen(true)
    onEngage && onEngage()
    onAwardPoints && onAwardPoints()
  }

  const handleCardClick = ({ cardClicked }) => {
    if (userTouchedCard === false) {
      analytics.stepEvent('step_interaction_memory_match_submit', step) //track the user's first click
      console.log(`card clicked: ${cardClicked}`)
    }
  }

  useEffect(() => {
    console.log('game begins')
    if (movesRemaining === 0) {
      setMovesRemaining(null)
    }
    setGameRunning(true)
  }, [])
  return (
    <section className="memory-match memory-match-step3">
      <div
        className={`step-content ${
          brk?.navigationType === 'TOP' ? 'top-navigation' : ''
        } ${step.backgroundImage ? ' with-shadow' : ''}`}
      >
        <div className="memory-match-header">
          {gameRunning === true && (
            <div className="memory-match-score">
              {movesRemaining !== null && (
                <span className="attempts">
                  {t('remainingAttempts', { remaining: movesRemaining })}
                </span>
              )}
            </div>
          )}
          {memoryMatchData.headline && (
            <h2
              className={'memory-match-headline step-content__title'}
              dangerouslySetInnerHTML={{ __html: memoryMatchData.headline }}
            />
          )}
        </div>
        <Game
          gameRunning={gameRunning}
          movesRemaining={movesRemaining}
          setMovesRemaining={setMovesRemaining}
          maxTries={memoryMatchData.possibleAttempts}
          stepCards={memoryMatchData.cards}
          onResults={handleResults}
          onCardClick={handleCardClick}
        />
        {results !== null && gameRunning === false && (
          <MemoryMatchResultsOverlay
            results={results}
            isOpen={resultsModalOpen}
            setIsOpen={setResultsModalOpen}
          />
        )}
        {socialShareComponent}
        {skipButton}
        {nextStepButton}
      </div>
    </section>
  )
}

export default MemoryMatchStep
